__turbopack_context__.v({
  "fallback": "split-text-module__McvV0q__fallback",
  "splitText": "split-text-module__McvV0q__splitText",
  "wrapper": "split-text-module__McvV0q__wrapper",
});
